/** Turkish-aware, accent-insensitive form for matching ("Şube" ~ "sube"). */
export const searchKey = (text: string): string =>
  text
    .toLocaleLowerCase('tr-TR')
    .replace(/ı/g, 'i')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '');

/** True when `text` contains every word of `query` (empty query matches). */
export const matchesQuery = (text: string, query: string): boolean => {
  const haystack = searchKey(text);
  return searchKey(query)
    .split(/\s+/)
    .filter(Boolean)
    .every((word) => haystack.includes(word));
};
